import { render, staticRenderFns } from "./NavMessages.vue?vue&type=template&id=1fd2c0ae&scoped=true&"
import script from "./NavMessages.vue?vue&type=script&lang=js&"
export * from "./NavMessages.vue?vue&type=script&lang=js&"
import style0 from "./NavMessages.vue?vue&type=style&index=0&id=1fd2c0ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd2c0ae",
  null
  
)

export default component.exports